import {
    ErrorId,
    FieldContent,
    Validator,
    FieldId,
    overrideValidator
} from '@sheerid/jslib';

const VALID_PHONE_NUMBER_REGEXPS = [
    /^\+?0*\d{10,}(x[0-9]{0,5})?$/,
    /(^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$)/,
];

export const setPhoneNumberValidator = () => {
    const phoneNumber: FieldId = 'phoneNumber';

    const getPhoneNumberValidationError: Validator = (value: FieldContent): ErrorId => {
        const invalidPhoneNumber: ErrorId = 'invalidPhoneNumber';
        if (!value) {
            return invalidPhoneNumber;
        }

        const matchedPatterns = VALID_PHONE_NUMBER_REGEXPS.filter((regexp: RegExp) => regexp.test(value as string));

        if (value && matchedPatterns.length === 0) {
            return invalidPhoneNumber;
        }
    };

    overrideValidator(phoneNumber, getPhoneNumberValidationError);
}
